/*
"texto":"texto", 
"cursoId":"cursoId", 
"estatusId":"estatusId", 
*/
import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio} from 'semantic-ui-react';
import { Link } from "react-router-dom";


const CursoAprendizajeForm=({ id, color, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos, cursoCombo})=>{



	return (
        <Container>
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

				<Header     dividing>             
					<Header.Content>{strings?strings["CursoAprendizaje"]:""}</Header.Content>
				</Header>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >
        
                              <Form.Field  required  error={errors.cursoId}>
                              <label  >{strings?strings["cursoId"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["cursoId"]:""} 
                                    name="cursoId"
									 fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={datos.cursoId}
                                    options={cursoCombo}/>
                            </Form.Field>
                        
                            <Form.Field  required  error={errors.texto}>            
                              <label  >{strings?strings["texto"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["texto"]:""} 
                                    name="texto"
                                    onChange={onChange}
                                    value={datos.texto}
                                    icon='edit'/>
                            </Form.Field>
                         
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/cursoaprendizajes">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default CursoAprendizajeForm;